






























































































import { Component, Prop, Emit } from 'nuxt-property-decorator'
import { uniqueId, cloneDeep } from 'lodash'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import {
  BODY_HEIGHT,
  Col,
  DataTableHeader
} from '@/components/molecules/DataTable'
import { RecycleScroller } from '@/components/molecules/RecycleScroller'
import { SystemCodeItem } from '@/types'

export interface ICodeTableHeader {
  text: string
  align: string
  sortable: boolean
  value: string
  width: string
}

export interface ICodeTableItem {
  id: number
  code: string
  name: string
  shortName: string
}

const COLS: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'check',
        align: 'center'
      }
    ]
  },
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: 80,
    resizable: true,
    movable: false,
    items: [
      {
        name: 'code',
        headerText: 'code'
      }
    ]
  },
  {
    width: '70',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'name',
        headerText: '正式形'
      }
    ]
  },
  {
    width: '30',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'shortName',
        headerText: '省略形'
      }
    ]
  }
]

@Component({
  components: {
    DataTable,
    DataTableHeader,
    RecycleScroller
  }
})
export default class CodeTable extends DataTable {
  @Prop({
    type: Array,
    default: []
  })
  items!: SystemCodeItem[]

  @Prop({
    type: Boolean,
    default: false
  })
  multiple!: boolean

  @Prop({
    type: Boolean
  })
  isAllSelect!: boolean

  @Prop({
    type: Number,
    default: BODY_HEIGHT
  })
  height!: number

  @Prop({
    type: Array,
    default: () => []
  })
  disabledCodes!: string[]

  get radioName(): string {
    return uniqueId('code-key-table-radio')
  }

  get checkName(): string {
    return uniqueId('code-key-table-check')
  }

  get showCols(): Col[] {
    if (this.multiple) return this.allCols

    const cols: Col[] = cloneDeep(this.allCols)
    cols[0].items[0].name = 'radio'

    return cols
  }

  get allCols(): Col[] {
    return COLS
  }

  // リサイクルスクローラ下にある為算出プロパティで対応
  get includesDisabledCodes(): (code: string) => boolean {
    return (code: string) => this.disabledCodes.includes(code)
  }

  onDoubleClickTableRow(): void {
    if (this.multiple) return

    this.$emit('dblclick:row')
  }

  onClickTableRow(index: number): void {
    const systemCode: SystemCodeItem = this.items[index]

    this.$logger.debug('CodeTable', 'onRowClick', 'systemCode=', systemCode)

    if (
      this.disabledCodes.includes(systemCode.code) ||
      (!this.multiple && systemCode.isSelected)
    ) {
      return
    }

    this.$emit('select:item', systemCode.code)

    this.$logger.debug('CodeTable', 'onRowClick', 'emit=', systemCode.code)
  }

  @Emit('all-select')
  onAllSelectChange(val: boolean): void {
    this.$logger.debug('CodeTable', 'onAllSelectChange', 'val=', val)
  }
}
